import { render } from "./AttivitaAll.vue?vue&type=template&id=5bc67f0b&scoped=true"
import script from "./AttivitaAll.vue?vue&type=script&lang=js"
export * from "./AttivitaAll.vue?vue&type=script&lang=js"

import "./AttivitaAll.vue?vue&type=style&index=0&id=5bc67f0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc67f0b"]])

export default __exports__